module.exports = __webpack_public_path__ + "img/装饰元素1@2x.94f1ab05.png";